import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate,
} from 'react-router-dom';
import Login from './auth-views/login/login';
import AppLayout from './app-layout';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PasswordChallenge from './auth-views/passwordChallenge';
import ForgotPassword from './auth-views/forgotPassword';
import { filterEnvioClientesFinales } from '../redux/actions/filters';

const Views = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const token = useSelector((state) => state.auth.token);
    const usuario = useSelector((state) => state.auth.usuario);
    const filters = useSelector((state) => state.filters);
    const dispatch = useDispatch();

    useEffect(() => {
        if (
            !token &&
            (location.pathname !== '/auth/passwordChallenge' ||
                location.pathname !== '/auth/forgotPassword')
        ) {
            navigate('/auth/login');
        }
        if (token && location.pathname === '/auth/login') {
            if (usuario?.rol?.id === 3) {
                // Entro como logistica
                navigate('/app/clientes');
            } else if (usuario?.rol?.id === 4) {
                // Entro como rol de impresion
                navigate('/app/inventario');
                dispatch(
                    filterEnvioClientesFinales({
                        filtersEnvioClientesFinales: {
                            ...filters.filterEnvioClientesFinales,
                            tab: 1, // Ordenes de Impresión
                        },
                    }),
                );
            } else if (usuario?.rol?.id === 7) {
                // Entro como promotor
                navigate('/app/promotor/mis-estadisticas');
            } else if (usuario?.rol?.id === 9) {
                // Entro como mensajero
                navigate('/app/ruta');
            } else {
                navigate('/app/dashboard');
            }
        }
        if (!usuario) {
            navigate('/auth/login');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <Routes>
            <Route path="auth">
                <Route path="login" element={<Login></Login>}></Route>
                <Route
                    path="forgotPassword"
                    element={<ForgotPassword></ForgotPassword>}
                />
                <Route
                    path="passwordChallenge"
                    element={<PasswordChallenge></PasswordChallenge>}
                ></Route>
            </Route>
            <Route path="app/*" element={<AppLayout></AppLayout>}></Route>
            <Route
                path="/*"
                element={<Navigate to="/auth/login"></Navigate>}
            ></Route>
        </Routes>
    );
};

export default Views;
